'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00241 from "./java.time.format.-Sign-Style$$anon$1.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00242 from "./java.time.format.-Sign-Style$$anon$2.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00243 from "./java.time.format.-Sign-Style$$anon$3.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00244 from "./java.time.format.-Sign-Style$$anon$4.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00245 from "./java.time.format.-Sign-Style$$anon$5.js";
var $p;
function $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NORMAL;
}
export { $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__ALWAYS;
}
export { $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NEVER;
}
export { $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE;
}
export { $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD;
}
export { $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle };
/** @constructor */
function $c_Ljava_time_format_SignStyle$() {
  $n_Ljava_time_format_SignStyle$ = this;
  $t_Ljava_time_format_SignStyle$__NORMAL = new $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00241.$c_Ljava_time_format_SignStyle$$anon$1();
  $t_Ljava_time_format_SignStyle$__ALWAYS = new $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00242.$c_Ljava_time_format_SignStyle$$anon$2();
  $t_Ljava_time_format_SignStyle$__NEVER = new $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00243.$c_Ljava_time_format_SignStyle$$anon$3();
  $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = new $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00244.$c_Ljava_time_format_SignStyle$$anon$4();
  $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = new $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024$0024anon$00245.$c_Ljava_time_format_SignStyle$$anon$5();
  $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
}
export { $c_Ljava_time_format_SignStyle$ as $c_Ljava_time_format_SignStyle$ };
$p = $c_Ljava_time_format_SignStyle$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_SignStyle$;
/** @constructor */
function $h_Ljava_time_format_SignStyle$() {
}
export { $h_Ljava_time_format_SignStyle$ as $h_Ljava_time_format_SignStyle$ };
$h_Ljava_time_format_SignStyle$.prototype = $p;
var $d_Ljava_time_format_SignStyle$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_SignStyle$, "java.time.format.SignStyle$", ({
  lp: 1,
  e: 1,
  aa: 1
}));
export { $d_Ljava_time_format_SignStyle$ as $d_Ljava_time_format_SignStyle$ };
var $n_Ljava_time_format_SignStyle$;
function $m_Ljava_time_format_SignStyle$() {
  if ((!$n_Ljava_time_format_SignStyle$)) {
    $n_Ljava_time_format_SignStyle$ = new $c_Ljava_time_format_SignStyle$();
  }
  return $n_Ljava_time_format_SignStyle$;
}
export { $m_Ljava_time_format_SignStyle$ as $m_Ljava_time_format_SignStyle$ };
var $t_Ljava_time_format_SignStyle$__NORMAL = null;
function $u_Ljava_time_format_SignStyle$__NORMAL(x) {
  $t_Ljava_time_format_SignStyle$__NORMAL = x;
}
export { $t_Ljava_time_format_SignStyle$__NORMAL as $t_Ljava_time_format_SignStyle$__NORMAL, $u_Ljava_time_format_SignStyle$__NORMAL as $u_Ljava_time_format_SignStyle$__NORMAL };
var $t_Ljava_time_format_SignStyle$__ALWAYS = null;
function $u_Ljava_time_format_SignStyle$__ALWAYS(x) {
  $t_Ljava_time_format_SignStyle$__ALWAYS = x;
}
export { $t_Ljava_time_format_SignStyle$__ALWAYS as $t_Ljava_time_format_SignStyle$__ALWAYS, $u_Ljava_time_format_SignStyle$__ALWAYS as $u_Ljava_time_format_SignStyle$__ALWAYS };
var $t_Ljava_time_format_SignStyle$__NEVER = null;
function $u_Ljava_time_format_SignStyle$__NEVER(x) {
  $t_Ljava_time_format_SignStyle$__NEVER = x;
}
export { $t_Ljava_time_format_SignStyle$__NEVER as $t_Ljava_time_format_SignStyle$__NEVER, $u_Ljava_time_format_SignStyle$__NEVER as $u_Ljava_time_format_SignStyle$__NEVER };
var $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = null;
function $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE(x) {
  $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = x;
}
export { $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE as $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE, $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE as $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE };
var $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = null;
function $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD(x) {
  $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = x;
}
export { $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD as $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD, $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD as $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD };
